import { MediaType } from '../../constants'
import { getFileMimeType, getMediaTypeFromMime } from '../../utils'

export const hasMixedMediaTypes = (files: File[]): boolean => {
  const fileMediaTypes = files.map((file) =>
    getMediaTypeFromMime(getFileMimeType(file)),
  )

  const uniqueFileMediaTypes = new Set(fileMediaTypes)
  uniqueFileMediaTypes.delete(MediaType.unsupported)

  return uniqueFileMediaTypes.size > 1
}
